import React, { PureComponent } from 'react';
import b from 'b_';

import './project-item.stub.css';

import Rect from '@components/rect';

const class_ = b.with('project-item-stub');

interface Props {
    type: 'horizontal' | 'vertical';
}

export default class ProjectItemStub extends PureComponent<Props> {
    public render() {
        const { type } = this.props;

        return (
            <div className={class_({ type })}>
                <Rect
                    className={class_('image')}
                    width={type === 'horizontal' ? 220 : 301}
                    height={150}
                />
                <div className={class_('info')}>
                    <Rect
                        className={class_('title')}
                        width={'100%'}
                        type="black"
                    />

                    {type === 'horizontal' && (
                        <Rect
                            className={class_('description')}
                            width={'100%'}
                            height={50}
                        />
                    )}

                    <Rect
                        className={class_('date')}
                        width={120}
                        height={20}
                    />
                </div>
            </div>
        );
    }
}
